import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { EligibilityType } from "./EligibilityType";
import type { JpClassTypeOverrideDTOBase } from "./JpClassTypeOverrideDTOBase";
import type { JpClassTypeStaff } from "./JpClassTypeStaff";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedBase } from "./TrackedBase";

export class JpClassTypeOverrideStaff implements JpClassTypeOverrideDTOBase, TrackedBase {
  constructor(public readonly rowId: number, public readonly personId: PersonStaff | null, public readonly typeId: JpClassTypeStaff | null, public readonly season: number | null, public readonly overrideType: EligibilityType, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.typeIdLoaded = this.typeId != null;
    this.typeIdCached = this.typeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private typeIdLoaded: boolean;
  private typeIdCached: JpClassTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.jpClassService().getJpClassTypeOverrideStaffPersonId(this.rowId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async typeIdLazy(): Promise<JpClassTypeStaff> {
    if (!this.typeIdLoaded) {
      this.typeIdCached = await this.cbiServiceContext!.jpClassService().getJpClassTypeOverrideStaffTypeId(this.rowId);
      this.typeIdLoaded = true;
    }
    return this.typeIdCached!;
  }
}
